import api from "../axios/index";

const getAccountId = () => {
  return sessionStorage.getItem("acc_id");
};

export async function getExternalProviders(active) {
  const response = await api.get("/external_providers/", {
    params: {
      active: active,
    },
  });
  return response.data;
}

export async function addExternalProvider(body) {
  const response = await api.post("/accounts/external-providers/", body);
  return response.data;
}

export async function deleteExternalProvider(providerId) {
  const response = await api.patch(
    `/accounts/external-providers/${providerId}/toggle-active/`
  );
  return response.data;
}
